import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { InputCustom, Loading, HttpError } from "../../components"
import * as ApiHelper from "../../ApiHelper"
class PendenciaForm extends Component {
  constructor() {
    super()
    this.getInitialFields = this.getInitialFields.bind(this)
    this.fillFields = this.fillFields.bind(this)
    this.onChangePendencia = this.onChangePendencia.bind(this)
    this.onChangeReferencia = this.onChangeReferencia.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.state = {
      referencia: "",
      pendencia: "",
      solicitacaoID: "",
      showForm: false
    }
  }

  componentWillMount() {
    this.getInitialFields()
  }

  getInitialFields() {
    ApiHelper.getSolicitacoesPendenciasEdit(
      this.props.pendenciaId,
      (pendencia, error) => {
        if (pendencia) {
          this.fillFields(pendencia)
          this.setState(
            {
              showForm: true
            },
            () => {
              window.scrollTo(0, 0)
            }
          )
        } else {
          this.setState({
            httpError: error
          })
        }
      }
    )
  }
  sendForm() {
    var params = {
      pendencia: this.state.pendencia,
      ref_contratual: this.state.referencia,
      sol_e_p_id: this.state.solicitacaoID
    }
    ApiHelper.updatePendencia(this.props.pendenciaId, params, error => {
      if (error) {
        this.handleErrors(error)
      } else {
        this.props.callBackPendencias()
      }
    })
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors)
    var errorsValue = errorsJSON.erros
    var errorsState = {}
    for (var key in errorsValue) {
      errorsState[key + "Error"] = errorsValue[key][0]
    }
    this.setState(errorsState)
  }
  fillFields(fields) {
    var currentFields = {
      pendencia: fields.pendencia,
      referencia: fields.ref_contratual,
      solicitacaoID: fields.sol_e_p_id
    }
    this.setState(currentFields)
  }
  onChangeReferencia(event) {
    var newValue = event.target.value
    this.setState({
      ref_contratualError: "",
      referencia: newValue
    })
  }
  onChangePendencia(event) {
    var newValue = event.target.value
    this.setState({
      pendenciaError: "",
      pendencia: newValue
    })
  }
  render() {
    if (this.state.httpError) {
      return (
        <div className="container-fluid">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </div>
      )
    }
    if (!this.state.showForm) {
      return <Loading />
    }
    return (
      <div className="container-fluid">
        <div className="card card-plain">
          <div className="card-header" data-background-color="as-blue">
            <h4 className="title">Editar item solicitação/esclarecimentos</h4>
            <p className="category">
              Editar item de solicitação de esclarecimentos pendência
            </p>
          </div>
          <div className="card-content">
            <InputCustom
              error={this.state.pendenciaError}
              sizeClass="col-md-5"
              label="Pendência"
              onChange={this.onChangePendencia}
              value={this.state.pendencia}
            />
            <InputCustom
              error={this.state.ref_contratualError}
              sizeClass="col-md-5"
              label="Referência contratual"
              onChange={this.onChangeReferencia}
              value={this.state.referencia}
            />
          </div>
          <button
            onClick={this.sendForm}
            type="submit"
            className="btn btn-primary pull-right"
            data-background-color="as-blue"
          >
            Salvar
          </button>
        </div>
      </div>
    )
  }
}
export default withRouter(PendenciaForm)



// WEBPACK FOOTER //
// ./src/views/modais/PendenciaForm.js